import eco1 from "./res/eco1.jpeg";
import eco2 from "./res/eco2.jpeg";
import eco3 from "./res/eco3.jpeg";
import eco4 from "./res/eco4.jpeg";
import eco5 from "./res/eco5.jpeg";
import eco6 from "./res/eco6.jpeg";
import eco7 from "./res/eco7.jpeg";
import eco8 from "./res/eco8.jpeg";
import eco9 from "./res/eco9.jpeg";
import eco10 from "./res/eco10.jpeg";
import eco11 from "./res/eco11.jpeg";
import pop1 from "./res/pop1.jpg";
import pop2 from "./res/pop2.jpg";
import pop3 from "./res/pop3.jpg";
import pop4 from "./res/pop4.jpg";
import pop5 from "./res/pop5.jpg";
import pop6 from "./res/pop6.jpg";
import pop7 from "./res/pop7.jpg";
import pop8 from "./res/pop8.jpg";
import pop9 from "./res/pop9.jpg";
import pop10 from "./res/pop10.jpg";
import pop11 from "./res/pop11.jpg";
import pop12 from "./res/pop12.jpg";
import pop13 from "./res/pop13.jpg";
import pop14 from "./res/pop14.jpg";
import pop15 from "./res/pop15.jpg";
import pop16 from "./res/pop16.jpg";
import pop17 from "./res/pop17.jpg";
import pop18 from "./res/pop18.jpg";
import pop19 from "./res/pop19.jpg";

var ECO = [
  {
    id: 1,
    title: "Eco Friendly Bappa 1",
    price: 1299,
    imgSrc: eco1,
    quantity: 1,
  },
  {
    id: 2,
    title: "Eco Friendly Bappa 2",
    price: 1499,
    imgSrc: eco2,
    quantity: 1,
  },
  {
    id: 3,
    title: "Eco Friendly Bappa 3",
    price: 999,
    imgSrc: eco3,
    quantity: 1,
  },
  {
    id: 4,
    title: "Eco Friendly Bappa 4",
    price: 1999,
    imgSrc: eco4,
    quantity: 1,
  },
  {
    id: 5,
    title: "Eco Friendly Bappa 5",
    price: 4999,
    imgSrc: eco5,
    quantity: 1,
  },
  {
    id: 6,
    title: "Eco Friendly Bappa 6",
    price: 3999,
    imgSrc: eco6,
    quantity: 1,
  },
  {
    id: 7,
    title: "Eco Friendly Bappa 7",
    price: 3499,
    imgSrc: eco7,
    quantity: 1,
  },
  {
    id: 8,
    title: "Eco Friendly Bappa 8",
    price: 4999,
    imgSrc: eco8,
    quantity: 1,
  },
  {
    id: 9,
    title: "Eco Friendly Bappa 9",
    price: 4599,
    imgSrc: eco9,
    quantity: 1,
  },
  {
    id: 10,
    title: "Eco Friendly Bappa 10",
    price: 3599,
    imgSrc: eco10,
    quantity: 1,
  },
  {
    id: 11,
    title: "Eco Friendly Bappa 11",
    price: 3999,
    imgSrc: eco11,
    quantity: 1,
  },
];
var POP = [
  {
    id: 12,
    title: "Bappa 12",
    price: 1999,
    imgSrc: pop1,
    quantity: 1,
  },
  {
    id: 13,
    title: "Bappa 13",
    price: 699,
    imgSrc: pop2,
    quantity: 1,
  },
  {
    id: 14,
    title: "Bappa 14",
    price: 1999,
    imgSrc: pop3,
    quantity: 1,
  },
  {
    id: 15,
    title: "Bappa 15",
    price: 699,
    imgSrc: pop4,
    quantity: 1,
  },
  {
    id: 16,
    title: "Bappa 16",
    price: 699,
    imgSrc: pop5,
    quantity: 1,
  },
  {
    id: 17,
    title: "Bappa 17",
    price: 699,
    imgSrc: pop6,
    quantity: 1,
  },
  {
    id: 18,
    title: "Bappa 18",
    price: 699,
    imgSrc: pop7,
    quantity: 1,
  },
  {
    id: 19,
    title: "Bappa 19",
    price: 699,
    imgSrc: pop8,
    quantity: 1,
  },
  {
    id: 20,
    title: "Bappa 20",
    price: 699,
    imgSrc: pop9,
    quantity: 1,
  },
  {
    id: 21,
    title: "Bappa 21",
    price: 699,
    imgSrc: pop10,
    quantity: 1,
  },
  {
    id: 22,
    title: "Bappa 22",
    price: 699,
    imgSrc: pop11,
    quantity: 1,
  },
  {
    id: 23,
    title: "Bappa 23",
    price: 699,
    imgSrc: pop12,
    quantity: 1,
  },
  {
    id: 24,
    title: "Bappa 24",
    price: 699,
    imgSrc: pop13,
    quantity: 1,
  },
  {
    id: 25,
    title: "Bappa 25",
    price: 699,
    imgSrc: pop14,
    quantity: 1,
  },
  {
    id: 26,
    title: "Bappa 26",
    price: 699,
    imgSrc: pop15,
    quantity: 1,
  },
  {
    id: 27,
    title: "Bappa 27",
    price: 699,
    imgSrc: pop16,
    quantity: 1,
  },
  {
    id: 28,
    title: "Bappa 28",
    price: 699,
    imgSrc: pop17,
    quantity: 1,
  },
  {
    id: 29,
    title: "Bappa 29",
    price: 699,
    imgSrc: pop18,
    quantity: 1,
  },
  {
    id: 30,
    title: "Bappa 30",
    price: 699,
    imgSrc: pop19,
    quantity: 1,
  },
];

var ITEMS = [ECO, POP];

export default ITEMS;
